import axios from "axios";
import React, { useState, useEffect, useMemo } from "react"
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { filterdata } from "../../helper/mapSearchData";


function MainHeaderSection(props) {

    const { t, i18n } = useTranslation('common');

    useEffect(() => {


        if (props?.lan == 'en') {
            i18next.changeLanguage("en");
        } else {
            i18next.changeLanguage("el");
        }

    }, [])
    const [toggle, setToggle] = useState(false);
    const [toggle1, setToggle1] = useState(false);
    const [trades_data, setTradesData] = useState([]);
    const [locations_data, setLocationData] = useState([]);

    var [checkedQuickFilterData, setCheckedQuickFilterData] = useState([]);

    useEffect(() => {

        if (!props?.map_area1) {
            if (props.trade_name) {

                document.getElementsByClassName('rem_location_input')[0].value = props.Dtrade_name;
                document.getElementsByClassName('rem_location_input')[0].setAttribute('SelectValueID', props.trade_name);
            }
            if (props.location_name) {
                document.getElementsByClassName('rem_trade_input')[0].value = props.Dlocation_name;
                document.getElementsByClassName('rem_trade_input')[0].setAttribute('SelectValueID', props.location_name);
            }
            // setTradesData(props?.trade_data.data);
            // setLocationData(props?.location_data.data);
        } else {
            if (document.getElementsByClassName('mobile_location_data')[0]) {
                document.getElementsByClassName('mobile_location_data')[0].innerHTML = props.Dlocation_name;
                document.getElementsByClassName('mobile_location_data')[0].setAttribute('SelectValueID', props.location_name);
            }
            if (document.getElementsByClassName('mobile_location_data')[1]) {
                document.getElementsByClassName('mobile_location_data')[1].innerHTML = props.Dlocation_name;
            }
            if (document.getElementsByClassName('mobile_trade_data')[0]) {
                document.getElementsByClassName('mobile_trade_data')[0].innerHTML = props.Dtrade_name;
                document.getElementsByClassName('mobile_trade_data')[0].setAttribute('SelectValueID', props.trade_name);
            }
            if (document.getElementsByClassName('mobile_trade_data')[1]) {
                document.getElementsByClassName('mobile_trade_data')[1].innerHTML = props.Dtrade_name;
            }
        }
    }, []);

    // componentDidMount(() => {
    //     alert('dasf');
    // });
    function setTrades_data(item) {

        if (props.trade_name == item.slug) {
            document.getElementsByClassName('rem_location_input')[0].value = item.title;
            document.getElementsByClassName('rem_location_input')[0].setAttribute('SelectValueID', item.slug);
        }
    }

    function setLocation_data(item2) {
        if (props.location_name == item2.slug) {
            document.getElementsByClassName('rem_trade_input')[0].value = item2.title;
            document.getElementsByClassName('rem_trade_input')[0].setAttribute('SelectValueID', item2.slug);
        }
    }

    function setInputValue(e) {
        setToggle(false);
        setToggle1(false);
        const index = e.target.getAttribute("data-index");
        const value = e.target.getAttribute("data-label");
        const valueID = e.target.getAttribute("data-value");
        if (index == 0) {
            document.getElementsByClassName('rem_trade_input')[0].value = value;
            document.getElementsByClassName('rem_trade_input')[0].setAttribute('SelectValueID', valueID);
        }
        if (index == 1) {
            document.getElementsByClassName('rem_location_input')[0].value = value;
            document.getElementsByClassName('rem_location_input')[0].setAttribute('SelectValueID', valueID);
        }
        jQuery('.filter-search-result').hide();
    }

    function changed_value(e) {

    }

    function redirect_tosearch_page() {
        const data2 = document.getElementsByClassName('rem_trade_input')[0].getAttribute('SelectValueID');
        const data1 = document.getElementsByClassName('rem_location_input')[0].getAttribute('SelectValueID');
        if (data2 && data1) {
            const url = props.site_url + (props?.lan ? '/' + props?.lan : '') + '/' + (data1 ? data1 : props.trade_name) + '/' + (data2 ? data2 : props.location_name) + "/";
            window.location.href = url;
        }
    }

    function showSearchModel() {
        document.getElementsByClassName('mobile_serach_module')[0].style.display = "block";
        props.onChange(true);
    }


    function openMapData() {
        document.getElementsByClassName('mobile_map_module')[0].style.display = "block";
        document.querySelector("body").classList.add("overflow-hidden");
        props.onChange(true);
    }

    function CloseMapModel() {
        document.getElementsByClassName('mobile_map_module')[0].style.display = "none";
        document.querySelector("body").classList.remove("overflow-hidden");

    }

    function openQuickFilter() {
        const style = document.getElementsByClassName('mobile_filter_wrapper')[0].style.display;
        if (style == 'block') {
            document.getElementsByClassName('mobile_filter_wrapper')[0].style.display = "none";
        } else {
            document.getElementsByClassName('mobile_filter_wrapper')[0].style.display = "block";
        }
        props.onChange(true);
    }

    function openMenuBar() {
        document.getElementsByClassName('mobile_menu_module')[0].style.display = "block";
    }

    // function open_dropDown1() {
    //    // jQuery('.filter_1').show();
    //    var pluginUrl = 'https://tamastoria.topwebsites.dev/wp-content/plugins';
    //    var items = [];
    //    var json_file = pluginUrl + '/brads-boilerplate-block-plugin/trade_file.json';
    //    jQuery.getJSON(json_file, function (data) {
    //        jQuery.each(data.data, function (key, val) {

    //            items.push({
    //                title: val.name,
    //                slug: val.slug,

    //            });


    //        });
    //     setTradesData(items);

    //    });
    // }
    // function open_dropDown2() {
    //     //jQuery('.filter_2').show();
    //     var pluginUrl = 'https://tamastoria.topwebsites.dev/wp-content/plugins';
    //     var items = [];
    //     var json_file = pluginUrl + '/brads-boilerplate-block-plugin/location_file.json';
    //     jQuery.getJSON(json_file, function (data) {
    //         jQuery.each(data.data, function (key, val) {
    //             jQuery.each(val, function (key, location_val) {

    //             items.push({
    //                 title: location_val.name,
    //                 slug: location_val.slug,

    //             });
    //         });

    //         });
    //        setLocationData(items);

    //     });
    // }
    jQuery(document).on('click', function (event) {
        if (!jQuery(event.target).closest('.filter-sec').length) {
            setToggle(false);
            setToggle1(false);
            jQuery('.filter-search-result').hide();
        }
    });
    async function filterTradeData(obj) {
        setToggle(true);
        jQuery('.filter-search-result').hide();
        jQuery(obj.target).parent().find('.filter-search-result').show();

        // console.log(jQuery(obj.target).parent().find('.filter-search-result').attr('style','display:block !important'));
        const data = await filterdata(obj.target.value, 'trade_file.json');

        setTradesData(data);
    }
    async function filterLocationData(obj) {
        setToggle1(true);
        jQuery('.filter-search-result').hide();
        jQuery(obj.target).parent().find('.filter-search-result').show();

        // console.log(jQuery(obj.target).parent().find('.filter-search-result').attr('style','display:block !important'));
        const data = await filterdata(obj.target.value, 'location_file.json');

        setLocationData(data);
    }
    jQuery(document).on('click', '.filter-select-arrow_wrapper1', function () {
        // jQuery(this).find('.filter-select-arrow').trigger('click');
        setToggle1(false);
        var pluginUrl = props.site_url + '/wp-content/plugins';
        var items = [];
        var json_file = pluginUrl + '/brads-boilerplate-block-plugin/trade_file.json';
        jQuery.getJSON(json_file, function (data) {
            jQuery.each(data.data, function (key, val) {

                items.push({
                    title: val.name,
                    slug: val.slug,

                });


            });

            setTradesData(items);


        });
        jQuery(this).parent().parent().find('.filter-search-result').show();


    });
    jQuery(document).on('click', '.filter-select-arrow_wrapper2', function () {
        setToggle(false);
        // jQuery(this).find('.filter-select-arrow').trigger('click');
        var tradeValue = jQuery("#inlineFormInput").attr("selectvalueid");

        var pluginUrl = props.site_url + '/wp-content/plugins';
        var items = [];
        var json_file = pluginUrl + '/brads-boilerplate-block-plugin/location_file.json';
        if (tradeValue && tradeValue != "") {
            var button = document.querySelector('.filter-select-arrow');

            if (button) {
                // Disable the button
                button.disabled = false;
            }
            var url_1 = props.site_url + '/wp-json/myapi/v1/get_location_val?trade=' + tradeValue;

            if (url_1) {
                var data = axios.get(url_1).then((response) => {
                    if (response?.data?.data == "") {
                        setLocationData(items);
                        jQuery('.no_result_found').css('display', 'block');
                        
                    } else {
                        jQuery.each(response?.data?.data, function (key, location_val) {
                            items.push({
                                title: location_val.name,
                                slug: location_val.slug,
                                parent: location_val.parent_name,

                            });
                        });
                        setLocationData(items);
                        jQuery('.no_result_found').css('display', 'none');
                    }

                });

                jQuery(this).parent().parent().find('.filter-search-result').show();
            }
    } else {
        var button = document.querySelector('.filter-select-arrow');

        if (button) {
            // Disable the button
            button.disabled = true;
        }
    //     jQuery.getJSON(json_file, function (data) {
    //         jQuery.each(data.data, function (key, val) {
    //             jQuery.each(val, function (key, location_val) {

    //                 items.push({
    //                     title: location_val.name,
    //                     slug: location_val.slug,
    //                     parent: location_val.parent,

    //                 });
    //             });

    //         });
    //         setLocationData(items);

    //     });
     }
    //     jQuery(this).parent().parent().find('.filter-search-result').show();


});
return (<header id="mobb-header" class={(props?.map_area) && 'mobile_header'}>
    <div class="container-fluid">
        <div class={(!(props?.map_area) && 'py-3') + " row align-items-center mobil-padd"}>
            {
                !(props?.map_area) && <div class="col-md-2 col-sm-6 text-center order1">
                    <a href={props.site_url} class="logo">
                        <img src={props.site_url + '/wp-content/uploads/2022/10/mastoria-logo.png'} />
                    </a>
                </div>
            }


            {!(props?.map_area1) && <div class="col-md-7 col-sm-12 order2 mobile_header_section-hide">
                <form autocomplete="off">
                    <div class="form-row align-items-center header-form">
                        <input type="hidden" value={props?.lan} id="current_lan" name="current_lan" />
                        <div class="col-auto p-0 border-cl-sec filter-sec">

                            <img class="rem_heart_icon" src={props.site_url + "/wp-content/uploads/2023/03/search-finder-pin.svg"} />
                            <input type="text" onKeyUp={filterTradeData} onChange={changed_value} class="form-control filter-form-group-dropdown filter_page_input rem_location_input" id="inlineFormInput" placeholder="Trades" />
                            <div class="filter-select-arrow_wrapper filter-select-arrow_wrapper1" onClick={() => setToggle(!toggle)}>
                                <span class="filter-select-arrow"  ></span>
                            </div>
                            {toggle && (<div class="filter-search-result">
                                <ul>

                                    {trades_data.map(function (object, i) {
                                        return <li onClick={setInputValue} data-index="1" data-label={object.title} data-value={object.slug}>{object.title}</li>
                                    })}
                                </ul>
                                <div class="no_result_found"><b>{t('No result found')}</b></div>
                            </div>
                            )}
                        </div>

                        <div class="col-auto p-0 filter-sec">
                            <img class="rem_heart_icon" src={props.site_url + "/wp-content/uploads/2023/03/search-map-pin.svg"} />
                            <input type="text" onKeyUp={filterLocationData} onChange={changed_value} class="form-control filter-form-group-dropdown filter_page_input rem_trade_input" id="inlineFormInputGroup" placeholder="Locations" />
                            <div class="filter-select-arrow_wrapper filter-select-arrow_wrapper2" onClick={() => setToggle1(!toggle1)}>
                                <span class="filter-select-arrow" ></span>
                            </div>
                            {toggle1 && (<div class="filter-search-result">
                                <ul>

                                    {(locations_data) ? locations_data.map(function (child_val, i) {
                                        if (child_val?.parent == 0) {
                                            var data = (<li class="rem_parent_location " data-index="0" onClick={setInputValue} data-label={child_val?.title} data-value={child_val?.slug}>{child_val?.title}</li>);
                                            return data;
                                        }

                                        var data = (<li class="rem_child_location" data-index="0" onClick={setInputValue} data-label={child_val?.title} data-value={child_val?.slug}>{child_val?.title}</li>);
                                        return data;
                                    }) : ''
                                    }
                                </ul>
                                <div class="no_result_found"><b>{t('No result found')}</b></div>
                            </div>
                            )}
                        </div>
                        <div class="col-auto p-0">
                            <button type="button" onClick={redirect_tosearch_page} class="btn btn-primary mobile_btn_hide">
                                <img class="rem_search_icon" src={props.site_url + "/wp-content/uploads/2023/03/search-find-button.svg"} width="20" />
                            </button>
                        </div>
                    </div>
                </form>
            </div>}


            <div class="col-md-8 col-sm-12 order2 mobile_header_section mobile_header_section_show">
                <form autocomplete="off">
                    <div class="form-row align-items-center header-form">
                        {/* <div class="rem_menu_bar" onClick={openMenuBar}> <i class="fa-solid fa-bars"></i> </div> */}
                        <div class="rem_menu_bar" > <span dangerouslySetInnerHTML={{ __html: window.elementor_menu }}></span> </div>
                        <div class="col-auto p-0 border-cl-sec filter-sec mobile_search_bar_rem" onClick={showSearchModel}>
                            <img class="rem_heart_icon search_icon_mobile" src={props.site_url + "/wp-content/uploads/2023/03/search-find-button.svg"} width="20" />

                            <label type="location" class="label_location label_electrician mobile_location_data"></label>


                            <label type="location" class="label_location label_llioupoli mobile_trade_data"></label>

                            <input type="text" readonly="true" onKeyUp={filterLocationData} onChange={changed_value} class="form-control filter-form-group-dropdown filter_page_input rem_location_input" id="inlineFormInput" placeholder="" />
                        </div>


                        {
                            !(props?.map_area) ? <div class="col-auto p-0 filter-sec">
                                <a href="#" class="location-image_show" onClick={openMapData}> <img class="rem_heart_icon" src={props.site_url + "/wp-content/uploads/2022/09/location-dot-solid.svg"} /></a>

                                <div class="filter-search-result">
                                    <ul>

                                        {(locations_data) ? locations_data.map(function (child_val, i) {

                                            if (child_val?.parent == 0) {
                                                var data = (<li class="rem_parent_location " data-index="0" onClick={setInputValue} data-label={child_val?.title} data-value={child_val?.slug}>{child_val?.title}</li>);
                                                return data;
                                            }

                                            var data = (<li class="rem_child_location" data-index="0" onClick={setInputValue} data-label={child_val?.title} data-value={child_val?.slug}>{child_val?.title}</li>);
                                            return data;
                                        }) : ''
                                        }
                                    </ul>
                                    <div class="no_result_found"><b>No result found</b></div>
                                </div>
                            </div>
                                :
                                <div class="col-auto p-0 filter-sec">
                                    <span class="mapModelListBtn" onClick={CloseMapModel}>
                                        {t('List')}
                                    </span>
                                </div>
                        }

                        {
                            !(props?.map_area) && <div class="col-auto p-0 map_icon">
                                <button type="button" onClick={openQuickFilter} class="btn btn-primary btn_setting_icon">
                                    <img class="rem_search_icon" src={props.site_url + "/wp-content/uploads/2022/09/gear-solid.svg"} />
                                </button>
                            </div>
                        }
                    </div>
                </form>
            </div>
            {
                !(props?.map_area) && <div class="col-md-3 col-sm-6 text-center order3">
                    {/* <div class="rem_menu_bar" onClick={openMenuBar}> <i class="fa-solid fa-bars"></i> </div> */}
                    <div class="rem_menu_bar"> <span dangerouslySetInnerHTML={{ __html: window.elementor_menu }}></span> </div>
                    <p class="head-btn">

                        {/* <a class="rem_help_nemu" href=""> Help </a> <span class="rem_verticalLine">|</span> */}
                        <a class="rem_signup_registration" href=""><span dangerouslySetInnerHTML={{ __html: window.elementor_menu }}></span>
                            {/* <img src={props.site_url + "/wp-content/uploads/2022/08/noun-arrow-1776260.svg"} /> */}
                        </a>
                    </p>
                </div>
            }
        </div>
    </div>
</header>);
}

export default MainHeaderSection;